import { css } from "lit";

export const styles = css`
  :host {
    display: block;
  }

  .panel {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .label {
    display: block;
    margin-bottom: 4px;
    font-weight: 500;
  }

  .preset-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
  }
`;
